// Supabase Auth answers in English. Map the messages people actually meet
// on sign-up, sign-in and password pages to translation keys.
const AUTH_ERRORS: Array<[RegExp, string]> = [
  [/^Password should be at least (\d+) characters/i, "crm.auth.errors.weak_password"],
  [/^Invalid login credentials/i, "crm.auth.errors.invalid_credentials"],
  [/^Email not confirmed/i, "crm.auth.errors.email_not_confirmed"],
  [/^User already registered/i, "crm.auth.errors.user_exists"],
  [/rate limit exceeded/i, "crm.auth.errors.rate_limit"],
  [/^For security purposes, you can only request this after/i, "crm.auth.errors.rate_limit"],
  [/^Email link is invalid or has expired/i, "crm.auth.errors.link_expired"],
  [/^New password should be different/i, "crm.auth.errors.same_password"],
  [/^Unable to validate email address/i, "crm.auth.errors.invalid_email"],
  [/^Failed to fetch/i, "crm.auth.errors.network"],
];

export const authErrorKey = (
  message: string,
): { key: string; args: Record<string, unknown> } | null => {
  for (const [pattern, key] of AUTH_ERRORS) {
    const match = message.match(pattern);
    if (match) return { key, args: { min: match[1], _: message } };
  }
  return null;
};
